// src/pages/TermsOfServices.js

import React from "react";

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", color: "#333" }}>
      <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px" }}>Terms of Service</h1>

      <p style={{ marginBottom: "16px" }}>
        Welcome to Prabhat Tara Vidya Niketan. By accessing or using our website, services, or any integrated platforms including Facebook, you agree to the following terms and conditions. Please read them carefully.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>1. Acceptance of Terms</h2>
      <p style={{ marginBottom: "16px" }}>
        By using our site or services, you agree to comply with and be bound by these Terms of Service. If you do not agree, please do not use our services.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>2. Facebook Integration</h2>
      <p style={{ marginBottom: "16px" }}>
        When you connect to our platform via Facebook, we may access basic profile information through Facebook's Graph API. This includes your name, email, profile picture, and Facebook ID. This data is used solely to improve user experience and is never shared without your consent.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>3. User Responsibilities</h2>
      <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
        <li>You agree to provide accurate and complete information.</li>
        <li>You will not use the platform for any illegal or unauthorized purpose.</li>
        <li>You are responsible for maintaining the security of your account, especially if logged in via Facebook.</li>
      </ul>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>4. Use of Content</h2>
      <p style={{ marginBottom: "16px" }}>
        All educational material, branding, and content provided on our platform is the property of Prabhat Tara Vidya Niketan. You may not copy, reuse, or redistribute without written permission.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>5. Termination</h2>
      <p style={{ marginBottom: "16px" }}>
        We reserve the right to suspend or terminate access to our services at any time, without prior notice, for conduct that we believe violates these terms or is harmful to other users, us, or third parties.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>6. Modifications to Terms</h2>
      <p style={{ marginBottom: "16px" }}>
        We may revise these Terms of Service at any time. Continued use of the service after changes means you accept the revised terms.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>7. Limitation of Liability</h2>
      <p style={{ marginBottom: "16px" }}>
        We are not liable for any direct or indirect damages arising from your use of our services. All services are provided “as is” and “as available.”
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>8. Governing Law</h2>
      <p style={{ marginBottom: "16px" }}>
        These terms are governed by the laws of the State of Bihar, India, without regard to its conflict of law principles.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>9. Contact Information</h2>
      <p style={{ marginBottom: "8px" }}>For questions or concerns regarding these terms, contact us:</p>
      <ul style={{ marginLeft: "20px", marginBottom: "30px" }}>
        <li>Email: principal@prabhatvidyanikethan.com</li>
        <li>Phone: +91 9939988606 / +91 7654164726</li>
        <li>Address: Rajkhand, Goraul, Vaishali, Bihar, India</li>
      </ul>

      <p style={{ fontSize: "14px", color: "#666" }}>Last Updated: April 2025</p>
    </div>
  );
};

export default TermsOfService;
